/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@statsbomb/kitbag-components';
import {
  StarRatingEmptyStar,
  StarRatingFullStar,
  StarRatingRow,
} from './StarRating.styles';

const StarRating = ({ rating }) => {
  const fullStars = Math.floor(rating / 20);
  const emptyStars = 5 - fullStars;

  const starsArray = [
    ...Array(fullStars).fill(1),
    ...Array(emptyStars).fill(0),
  ];

  return (
    <StarRatingRow>
      {starsArray.map((filled, index) =>
        filled === 1 ? (
          <StarRatingFullStar data-testid="full-star">
            <Icon variant="StarFilled" key={`star-${index}`} size="small" />
          </StarRatingFullStar>
        ) : (
          <StarRatingEmptyStar data-testid="empty-star">
            <Icon variant="StarUnfilled" key={`star-${index}`} size="small" />
          </StarRatingEmptyStar>
        )
      )}
    </StarRatingRow>
  );
};

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
};

export default StarRating;
